import { makeStyles } from "@mui/styles";

export const AmenitiesDashboardStyle = makeStyles((theme) => ({
    root: {
        height: "calc(100vh - 120px)",
        overflow: "auto"
    }
}))